module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0126.jpg?v=4cdb30fa";